import Vue from 'vue';
import './plugins/axios'
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Notifications from 'vue-notification'
import moment from 'moment'
import { ApiService } from './services/api.service'
import {
  keycloak,
  keycloakProviderInitConfig,
} from "./utils/keycloak";

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ]
}

Vue.config.productionTip = false;

Vue.use(Notifications);

ApiService.setupInterceptor();

Vue.filter('formatDate', function (value: any) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY ')
  }
});

Vue.filter('formatTimestamp', function (value: any) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
});


Vue.filter('formatMoney', function (value: any) {
  if (value) {
    return formatter.format(value);
  }
});

var formatter = new Intl.NumberFormat('de', {
});

keycloak.onReady = ((authenticated) => {
  console.log("Keycloak Ready");
} );

keycloak.onAuthSuccess = () => {
  console.log("Auth Success");
};


keycloak.init(keycloakProviderInitConfig).then((auth) => {
  console.log("Init done");
  if (auth) {

      localStorage.setItem("user", JSON.stringify(keycloak.tokenParsed));
      //store.commit("userdata/SET_HAS_OPEN_SKONTO_VOUCHERS", tokenParsed?.skontoVouchers || []);
      store.commit("userdata/SET_HAS_OPEN_SKONTO_VOUCHERS", []);

      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App, { props: { keycloak: keycloak } }),
      }).$mount('#app');
    } else {
      keycloak.login()
    }

  //Token Refresh
  setInterval(() => {
    keycloak.updateToken(70).then((refreshed) => {

      if(keycloak.tokenParsed)
      {
        if (refreshed) {
          console.log('Token refreshed' + refreshed);
          localStorage.setItem("user", JSON.stringify(keycloak.tokenParsed));
        } else {
          console.log('Token not refreshed, valid for '
            + Math.round((keycloak.tokenParsed.exp ? keycloak.tokenParsed.exp : 0) + (keycloak.timeSkew ? keycloak.timeSkew : 0) - new Date().getTime() / 1000) + ' seconds');
        }
      }else{
        console.log('Failed to refresh token, parsed token is null');
      }

    }).catch(() => {
      console.log('Failed to refresh token');
    });
  }, 30000)
}).catch((reason) => {
  console.log("Authenticated Failed");
  alert("Authenticated Failed");
  console.log(reason);
  alert(JSON.stringify(reason));

});
